export const dataOrPlaceholder = (data, placeholder = ' - ') => (data ? data : placeholder);
